"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monthNames = void 0;
exports.monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
//# sourceMappingURL=monthNames.js.map